import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const SearchFilters = ({ 
  searchTerm, 
  onSearchChange, 
  classFilter, 
  onClassFilterChange,
  statusFilter,
  onStatusFilterChange,
  roleFilter,
  onRoleFilterChange,
  sortBy,
  onSortChange,
  sortDirection,
  onSortDirectionToggle
}) => {
  const classOptions = [
    { value: 'all', label: 'All Classes' },
    { value: 'warrior', label: 'Warrior' },
    { value: 'cleric', label: 'Cleric' },
    { value: 'rogue', label: 'Rogue' },
    { value: 'wizard', label: 'Wizard' },
    { value: 'ranger', label: 'Ranger' },
    { value: 'paladin', label: 'Paladin' },
    { value: 'necromancer', label: 'Necromancer' },
    { value: 'enchanter', label: 'Enchanter' },
    { value: 'magician', label: 'Magician' },
    { value: 'bard', label: 'Bard' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'online', label: 'Online' },
    { value: 'away', label: 'Away' },
    { value: 'offline', label: 'Offline' }
  ];

  const roleOptions = [
    { value: 'all', label: 'All Roles' },
    { value: 'officer', label: 'Officers Only' },
    { value: 'member', label: 'Members Only' }
  ];

  const sortOptions = [
    { value: 'name', label: 'Name' },
    { value: 'joinDate', label: 'Join Date' },
    { value: 'characterCount', label: 'Character Count' },
    { value: 'activity', label: 'Last Activity' }
  ];

  return (
    <div className="card mb-6 md:mb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <div className="lg:col-span-2">
          <Input
            type="search"
            placeholder="Search members or characters..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>

        <Select
          options={classOptions}
          value={classFilter}
          onChange={onClassFilterChange}
          placeholder="Filter by class"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          options={statusOptions}
          value={statusFilter}
          onChange={onStatusFilterChange}
          placeholder="Filter by status"
        />

        <Select
          options={roleOptions}
          value={roleFilter}
          onChange={onRoleFilterChange}
          placeholder="Filter by role"
        />

        <Select
          options={sortOptions}
          value={sortBy}
          onChange={onSortChange}
          placeholder="Sort by"
        />

        <button
          onClick={onSortDirectionToggle}
          className="px-4 py-2 rounded-lg bg-muted hover:bg-primary/20 text-foreground font-medium transition-base flex items-center justify-center gap-2"
          aria-label={`Sort ${sortDirection === 'asc' ? 'ascending' : 'descending'}`}
        >
          <Icon 
            name={sortDirection === 'asc' ? 'ArrowUp' : 'ArrowDown'} 
            size={18} 
          />
          <span className="hidden sm:inline">
            {sortDirection === 'asc' ? 'Ascending' : 'Descending'}
          </span>
        </button>
      </div>
    </div>
  );
};

export default SearchFilters;